import { render, staticRenderFns } from "./MaterialAlert.vue?vue&type=template&id=07c320b2"
import script from "./MaterialAlert.vue?vue&type=script&lang=js"
export * from "./MaterialAlert.vue?vue&type=script&lang=js"
import style0 from "./MaterialAlert.vue?vue&type=style&index=0&id=07c320b2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports